import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs/Observable';
import { IAppConfig } from '../../store/interfaces/IAppConfig';
import { APP_CONFIG } from '../config';
import { LogService } from '../services/logging.service';
import { ApigeeDAO } from './apigee.dao';
import { DefaultRetryHandler } from './handlers/retry.handlers';
import { DefaultDataValidator } from './validators/data.validators';

const CLASS_NAME = 'HasherDao';

@Injectable()
export class HasherDao extends ApigeeDAO {
  constructor(http: HttpClient, @Inject(APP_CONFIG) appConfig: IAppConfig, log: LogService, cookieService: CookieService) {
    super(CLASS_NAME, http, appConfig, appConfig.hasherDAO, new DefaultRetryHandler(), new DefaultDataValidator(), log, cookieService);
  }

  public get(confirmationNumber, firstName, lastName, checkInDate, checkOutDate, hotelCode): Observable<any> {
    const params = {
      searchType: !!confirmationNumber ? 'CONFIRMATION' : 'HOTEL_MNEMONIC',
      confirmationNumber,
      firstName,
      lastName,
      checkInDate,
      checkOutDate,
      hotelCode
    };
    return this.doGet(this.daoConfig.url, params);
  };

}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/daos/hasher.dao.ts